<div class="card">
    <div *ngFor="let col of columns">
        <ng-container *ngIf="currentCoupon[col.field] !== undefined">
            <div class="title-value" *ngIf="col.headerTranslate">
                {{ col.headerTranslate | translate }}
            </div>

            <div class="field-value" *ngIf="col.type === fieldTypes.icon">
                <img [src]="currentCoupon[col.field]" alt="icon" class="coupon-icon" />
            </div>

            <div class="field-value" *ngIf="col.type === fieldTypes.fullDate">
                {{ currentCoupon[col.field] | date: 'dd/MM/yyyy' }}
            </div>

            <div class="field-value" *ngIf="col.type === fieldTypes.link">
                <a target="_blank" rel="noopener noreferrer" [href]="currentCoupon[col.field]">
                    {{ getLinkText(col.field, currentCoupon[col.field]) }}
                </a>
            </div>

            <div class="field-value" *ngIf="col.type === fieldTypes.bool">
                   <div *ngIf="!currentCoupon[col.field]">
                            <i class="pi pi-times-circle" style="color: red;"></i>
                        </div>
                        <div *ngIf="currentCoupon[col.field]">
                            <i class="pi pi-check-circle" style="color: green;"></i>
                        </div>
            </div>

            <div class="field-value" *ngIf="!col.type">
                {{ currentCoupon[col.field] }}
            </div>
        </ng-container>
    </div>
    <button pButton type="button" icon="pi pi-envelope" class="resend-email-btn"
        label="{{ 'BUSINESS_COUPON.RESEND_EMAIL' | translate }}"
        [disabled]="!currentCoupon.customerEmail || !currentCoupon.couponCode"
        (click)="resend.emit(currentCoupon.couponCode)">
    </button>
</div>